import React, { memo } from 'react';
import Layout from "../components/layout/layout";

const days = [
  {
    "name": "Maandag",
    "frenchName": "Lundi",
    "englishName": "Monday",
    "closed": true
  },
  {
    "name": "Dinsdag",
    "frenchName": "Mardi",
    "englishName": "Tuesday",
    "soup": "Tomatensoep",
    "frenchSoup": "Soupe de tomates",
    "englishSoup": "Tomate soup",
    "mainCourse": "Scampi met look en frietjes",
    "frenchMainCourse": "Scampi à l'ail avec des frites",
    "englishMainCourse": "Scampi with garlic and fries",
    "dessert": null
  },
  {
    "name": "Woensdag",
    "frenchName": "Mercredi",
    "englishName": "Wednesday",
    "soup": "Groene seldersoep",
    "frenchSoup": "Soupe de cèleri vert",
    "englishSoup": "Green celery soup",
    "mainCourse": "Kippenfilet met ovenaardappelen, salade en roquefortsaus",
    "frenchMainCourse": "Filet de poulet avec pommes de terre au four, salade et sauce roquefort",
    "englishMainCourse": "Chicken fillet with oven-baked potatoes, salad, and roquefort sauce",
    "dessert": null
  },
  {
    "name": "Donderdag",
    "frenchName": "Jeudi",
    "englishName": "Thursday",
    "soup": "Couregettesoep",
    "frenchSoup": "Soupe de courgettes",
    "englishSoup": "Zucchini Soup",
    "mainCourse": "Kippenloempia met currysaus en rijst",
    "frenchMainCourse": "Loempia au poulet avec sauce curry et riz",
    "englishMainCourse": "Chicken spring roll with curry sauce and rice",
    "dessert": null
  },
  {
    "name": "Vrijdag",
    "frenchName": "Vendredi",
    "englishName": "Friday",
    "soup": "Paprikasoep",
    "frenchSoup": "Soupe de poivrons",
    "englishSoup": "Paprika soup",
    "mainCourse": "Doradefilet met wittewijnsaus en aardappelpuree",
    "frenchMainCourse": "Filet de dorade, sauce vin blanc et purée de pommes de terre",
    "englishMainCourse": "Sea bream fillet with white wine sauce and mashed potatoes",
    "dessert": null
  },
  {
    "name": "Zaterdag",
    "frenchName": "Samedi",
    "englishName": "Saturday",
    "soup": "Aspergesoep",
    "frenchSoup": "Soupe aux asperges",
    "englishSoup": "Asparagus soup",
    "mainCourse": "Varkens spare ribs met barbecuesaus en pittige aardappelenpartjes",
    "frenchMainCourse": "Spare ribs de porc, sauce barbecue et quartiers de pommes de terre épices",
    "englishMainCourse": "Pork spare ribs with barbecue sauce and spicy potato wedges",
    "dessert": null
  },
  {
    "name": "Zondag",
    "frenchName": "DimaNche",
    "englishName": "Sunday",
    "soup": "Aardappelsoep met spekjes",
    "frenchSoup": "Soupe de pommes de terre aux lardons",
    "englishSoup": "Potato soup with lardons",
    "mainCourse": "Kalkoenfilet, champignonsaus en kroketjes",
    "frenchMainCourse": "Filet de dinde à la sauce champignon et croquettes pommes de terre",
    "englishMainCourse": "Turkey fillet with mushroom sauce and potato croquettes",
    "dessert": null
  }
];

const Lunch = () => {
  return (
      <>
          <Layout/>
          <main className="main">
              <section className='lunch'/>
              <div className="best_price">
                  <img
                      loading='lazy'
                      src="/images/best_price_2.webp"
                      alt="Lunch"
                  />
              </div>
              <div className="top_title">
                  <h1>Lunch</h1>
              </div>

              <div className='lunch_wrap'>
                  <div className='lunch_box'>
                      <h3>07.04.2025 - 13.04.2025</h3>
                      <h3>11:30 – 15:00</h3>
                      {days.map((day, index) => (
                          <div key={index}>
                              <h4>{day.name} – {day.frenchName} – {day.englishName}</h4>
                              {day.closed ? (
                                  <p>Gesloten</p>
                              ) : (
                                  <>
                                      <p>{day.soup} - {day.frenchSoup} - {day.englishSoup}</p>
                                      <p>{day.mainCourse}</p>
                                      <p>{day.frenchMainCourse}</p>
                                      <p>{day.englishMainCourse}</p>
                                      {day.dessert && (
                                          <p>{day.dessert} - {day.frenchDessert} - {day.englishDessert}</p>
                                      )}
                                  </>
                              )}
                          </div>
                      ))}
                  </div>
              </div>
          </main>
      </>
  );
};

export default memo(Lunch);
